module.exports = __webpack_public_path__ + "static/media/airbnb.d9b04fcc.jpeg";